// @flow weak

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import 'app/common/components/Badge.scss';

import type { Node } from 'react';

import type { KindType } from 'app/common/types';

type BadgeProps = {
  kind?: KindType,
  className?: string,
  children?: Node,
};

const Badge = (props: BadgeProps) => {
  const bem = bemify('badge');
  const className = bem(toModifiers(props.kind), props.className);
  return <div className={className}>{props.children}</div>;
};

export default Badge;
